import { createContext, useContext } from 'react'

// dnd-kit's ref must be on the whole <tr> (so the drag overlay matches the row size),
// but only the grip icon nested in the Title cell should activate the drag.
type DocumentDragHandle = { handleRef: (element: Element | null) => void } | null

const DocumentDragHandleContext = createContext<DocumentDragHandle>(null)

export const DocumentDragHandleProvider = DocumentDragHandleContext.Provider

export const useDocumentDragHandle = () => useContext(DocumentDragHandleContext)
